export const TIMESERIES_LIST_REQUEST = 'TIMESERIES_LIST_REQUEST';
export const TIMESERIES_LIST_SUCCESS = 'TIMESERIES_LIST_SUCCESS';
export const TIMESERIES_LIST_FAIL = 'TIMESERIES_LIST_FAIL';
export const SET_ACTIVE_TIMESCALE = 'SET_ACTIVE_TIMESCALE';
